// ExpertQuotesComponent.js
import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import Image from '../../Image/Image';

const INLINE_BOLD_REGEX = /(\*\*[^*]+\*\*|<b>[^<]+<\/b>)/g;

const renderRichText = (text) =>
  String(text || '')
    .split(INLINE_BOLD_REGEX)
    .map((part, index) => {
      if (/^\*\*[^*]+\*\*$/.test(part)) {
        return (
          <strong key={index} style={{ fontWeight: 700 }}>
            {part.slice(2, -2)}
          </strong>
        );
      }

      if (/^<b>[^<]+<\/b>$/.test(part)) {
        return (
          <strong key={index} style={{ fontWeight: 700 }}>
            {part.slice(3, -4)}
          </strong>
        );
      }

      return part;
    });

const ExpertQuotesComponent = ({ expertData }) => {
  const { image, quoteTitle, quoteText, expertName, expertLink } = expertData;

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          width: '1216px',
          maxHeight: '496px',
          borderRadius: '34px',
          backgroundColor: '#162F3B',
          padding: '80px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          position: 'relative',
          boxSizing: 'border-box',
        }}
      >
        {/* Expert Image */}
        <Image
          width={104}
          height={104}
          src={image}
          alt="Expert"
          sx={{
            width: '104px',
            height: '104px',
            position: 'absolute',
            borderRadius: '50%',
            objectFit: 'cover',
          }}
        />

        {/* Quote Text */}
        <Box sx={{ ml: '144px' }}>
          {quoteTitle ? (
            <Typography
              component="span"
              sx={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 700,
                fontSize: '2.125rem',
                lineHeight: '2.5rem',
                letterSpacing: '-0.03em',
                color: '#FFFFFF',
                textAlign: 'left',
              }}
            >
              {quoteTitle}
            </Typography>
          ) : null}
          <Typography
            component="span"
            sx={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 400,
              fontSize: '2.125rem',
              lineHeight: '2.5rem',
              letterSpacing: '-0.03em',
              color: '#FFFFFF',
              display: 'inline',
              textAlign: 'left',
              whiteSpace: 'pre-line',
            }}
          >
            {renderRichText(quoteText)}
          </Typography>
        </Box>

        {/* Expert Name */}
        <Typography
          sx={{
            fontFamily: 'Inter, sans-serif',
            fontWeight: 700,
            fontSize: '1rem',
            lineHeight: '1.5rem',
            letterSpacing: '-0.02em',
            color: '#FFFFFF',
            alignSelf: 'flex-start',
            ml: '144px',
            mt: '32px',
          }}
        >
          {expertName?.split(/(\*\*[^*]+\*\*|<G>[^<]+<G>)/g).map((part, i) => {
            if (/^\*\*[^*]+\*\*$/.test(part)) {
              // bold text between ** **
              return (
                <strong key={i} style={{ fontWeight: 700 }}>
                  {part.slice(2, -2)}
                </strong>
              );
            } else if (/^<G>[^<]+<G>$/.test(part)) {
              // green text between <G> <G>
              return (
                <span key={i} style={{ color: '#C7CA00' }}>
                  {
                    <Link
                      href={expertLink}
                      target="_blank"
                      underline="none"
                      sx={{
                        color: '#C7CA00',
                        fontWeight: 500,
                        cursor: 'pointer',
                        '&:hover': {
                          textDecoration: 'underline',
                          opacity: 0.9, // optional subtle feedback
                        },
                      }}
                    >
                      {part.slice(3, -3)}
                    </Link>
                  }
                </span>
              );
            } else {
              return part;
            }
          })}
        </Typography>
      </Box>
    </Box>
  );
};

export default ExpertQuotesComponent;
